'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AplusExparams = function () {
  function AplusExparams(dom) {
    _classCallCheck(this, AplusExparams);

    this.dom = dom;
    this.data = null;
  }

  AplusExparams.prototype.get = function get(id) {
    if (!this.data) {
      this.data = this.data || {};
      try {
        this._getDataFromDom();
      } catch (err) {
        // ...
      }
    }
    return this.data[id];
  };

  AplusExparams.prototype._getDataFromDom = function _getDataFromDom() {
    var _this = this;

    var elAplus = this.dom || document.getElementById('beacon-aplus');
    var attr = decodeURIComponent(elAplus.getAttribute('exparams') || '');
    attr.split('&').forEach(function (item) {
      var itemKey = item.split('=', 1)[0];
      _this.data[itemKey] = item.slice(itemKey.length + 1);
    });
  };

  return AplusExparams;
}();

var aplusExparams = new AplusExparams();
exports['default'] = aplusExparams;
module.exports = exports['default'];